import { createFileRoute } from "@tanstack/react-router";
import { SignupBonusPage } from "@/components/dashboard/signup-bonus-page";

export const Route = createFileRoute("/signup-bonus")({
  head: () => ({
    meta: [
      { title: "Signup bonus — Deuxda Admin" },
      { name: "description", content: "Set how many diamonds a new account receives." },
    ],
  }),
  component: () => <SignupBonusPage />,
});
